import React from 'react';
import Brand from '../../../../svg/shop.svg';
import { StampProps } from '../../../../types';
import { StampContainer } from '../Styled';

const Shop = ({ label }: StampProps) => (
  <StampContainer>
    <Brand />
    <span>{label}</span>
  </StampContainer>
);

Shop.defaultProps = {
  label: 'comprou e avaliou',
};

export default Shop;
export { Shop };
